/**
 * Deprecated shim. The rate card lives in `@homero/pricing`.
 *
 * These used to be hardcoded, unversioned string literals baked into the CRA
 * bundle — which is why the landing page still advertised the V2 table long
 * after this app moved to V4, and why a browser holding a cached bundle could
 * post a price the server no longer recognised. They are now derived from the
 * shared rate card.
 *
 * Prefer `src/lib/price.ts`, or `@homero/pricing` directly.
 */

import { ADD_ON_COST_CENTS } from "@homero/pricing";
import { currentPricingConfig } from "../lib/pricing-config";

const current = () => currentPricingConfig().rateCard.cleaningTypes;

const dollarString = (cents: number) => String(cents / 100);

export const ADD_ON_PRICE = {
  organizing: dollarString(ADD_ON_COST_CENTS.organizing),
  oven: dollarString(ADD_ON_COST_CENTS.oven),
  fridge: dollarString(ADD_ON_COST_CENTS.fridge),
  cabinets: dollarString(ADD_ON_COST_CENTS.cabinets),
  windows: dollarString(ADD_ON_COST_CENTS.windows),
  laundry: dollarString(ADD_ON_COST_CENTS.laundry),
};

/**
 * Getters, not values.
 *
 * These were evaluated once at module load, which was fine while the prices were
 * compile-time constants and is wrong now that they arrive from the API — a plain
 * object would capture the bundled fallback before the fetch resolved and hold it
 * for the life of the page. Getters keep the existing `CLEANING_TYPE_PRICE.Standard`
 * shape for every call site while reading the current config each time.
 */
export const CLEANING_TYPE_PRICE = {
  get Standard() {
    return dollarString(current().standard);
  },
  get "Special Mission"() {
    return dollarString(current().special_mission);
  },
  get "Super Clean"() {
    return dollarString(current().super_clean);
  },
  get "Move In / Out"() {
    return dollarString(current().move_in_out);
  },
};
